var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClickIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFA927",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#FFA927",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("path", {
    d: "M86.1782,60.7291,64.9688,39.52l8.4838-8.4837a6.002,6.002,0,0,0-2.8943-10.0891L15.4139,8.2213A6.0022,6.0022,0,0,0,8.2191,15.416L20.9447,70.56a6.0019,6.0019,0,0,0,10.0891,2.8943l8.4838-8.4837L60.7269,86.18a5.9974,5.9974,0,0,0,8.4838,0L86.1782,69.2129A5.9974,5.9974,0,0,0,86.1782,60.7291ZM64.9688,73.4547,43.7594,52.2454a5.9973,5.9973,0,0,0-8.4837,0l-5.0739,5.0738L22.07,22.0718,57.317,30.204l-5.0738,5.0739a5.9973,5.9973,0,0,0,0,8.4837L73.4526,64.971Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClickIcon);
export default __webpack_public_path__ + "static/media/click-icon.8451fa367e4711036457e81591effbc9.svg";
export { ForwardRef as ReactComponent };